import { FooterTypes } from '@dtx-company/true-common/src/types/footer'
import { MarketingNavTypes } from '@dtx-company/true-common/src/types/appContent'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export interface AppContent {
  footer: Partial<FooterTypes>
  marketingNav: MarketingNavTypes
}

export const appContentSlice = createSlice({
  name: 'appContent',
  initialState: null as AppContent | null,
  reducers: {
    setAppContent: (state, action: PayloadAction<AppContent>) => (state = action.payload)
  }
})

export const { setAppContent } = appContentSlice.actions

export default appContentSlice.reducer
